import React from "react";
import QueueAnim from "rc-queue-anim";
import { useTranslation } from "react-i18next";
import { getImageUrl } from "../config";
import "../css/banner.less";

const Banner: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div
      className="banner-wrapper"
      style={{
        backgroundImage: `url(${getImageUrl("/image/top1.jpeg")})`,
      }}
    >
      <QueueAnim
        className="banner-text-wrapper-1"
        type="left"
        duration={1000}
        delay={400}
        ease="easeInOutQuart"
      >
        <div key="content" className="banner-wrapper-content">
          {t("home.banner_lead")}<br />
          {t("home.banner_sub")}
        </div>
      </QueueAnim>

      <QueueAnim
        className="faq-wrapper"
        type="bottom"
        duration={1000}
        delay={400}
        ease="easeInOutQuart"
      >
        <a href="/faq" className="faq-wrapper-content-link">
          <span className="faq-wrapper-content-title">FAQ</span>
          <span className="faq-wrapper-content-description">{t("home.more_details")}</span>
          <div>
            <img src={getImageUrl("/image/icon_arrow_white.png")} alt="arrow" />
          </div>
        </a>
      </QueueAnim>
    </div>
  );
};

export default Banner;
